import store from "store2"

import header from './header/header'
import center from './center/center'
import footer from './footer/footer'
import subs from './subs/subs'
import shortcuts from './shortcuts/shortcuts'
import play from './play/play'

export default function(o, done){

  var lang = o.store('lang')

  if(!o.store('storySubtitleType')){
    if(lang == 'de'){
      o.store('storySubtitleType','off')
    } else {
      o.store('storySubtitleType',lang)
    }
  }

  var videoReady = false
  var isPlaying = false

  var parts = location.pathname.split('/')
  var titleSlug = parts[parts.length - 1]

  var storiesLabel = o.util.getTranslation(o, 'stories')

  o.data.movies(o, function(movieData){

    var movie =
      _.find(movieData, function(m){
        return Slug(m.en) == titleSlug
      })

    var loadSubs = function(onLoaded){

      var subsType = o.store('storySubtitleType')

      if(subsType != 'off' && movie.subs[subsType]){
  
        var subsFile = o.util.getUrl('sub') + movie.subs[subsType]
  
        $.get(subsFile, function(subsRaw) {
          onLoaded(subsRaw)
        })
  
      } else {
        onLoaded()
      }

    }

    var start = function(subsRaw){

      var movieTitle = movie[lang]

      document.title = `Open Memory Box | ${storiesLabel} | ${movieTitle}`

      var videoFile = movie.files[MaxResolution]
      var videoUrl = o.util.getUrl('movie',MaxResolution) + videoFile

      var durationSmpte = movie.duration
      var duration = o.util.smpteToSeconds(durationSmpte)

      var convertRemToPixels = function(rem) {
        return rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
      }
  
      var remPx = convertRemToPixels(1)
  
      var screenRatio = $(document).width() / $(document).height()
      var horizontaOffset = remPx * 0.5

      if(4/3 < screenRatio){
        var w = $(document).height() / 3 * 4
        var b = ($(document).width() - w) / 2
        var horizontaOffset = b
      }

      var onTimeUpdate = function(currentTime){

        if(currentTime && currentTime > 5){
          o.store(`storyCurrentTime_${titleSlug}`, currentTime)
        }

        var progress = currentTime / duration
        timelineDiv.update(progress)

        subsDiv.update(currentTime)

        if(!videoReady){
          shortcuts(onTogglePlay)
          videoReady = true
        }

      }

      var onTimeChange = function(progress){
        var currentTime = progress * duration
        videoDiv[0].currentTime = currentTime
      }

      var firstStart = true

      var onTogglePlay = function(){
        videoDiv.css({
          opacity: 1,
        })
        if(isPlaying){
          isPlaying = false
          videoDiv[0].pause()
          centerDiv.show()
          headerDiv.show()
          footerDiv.show()
          subsDiv.hide()
        } else {
          isPlaying = true
          videoDiv[0].play()
          centerDiv.hide()
          headerDiv.hide()
          footerDiv.hide()
          subsDiv.show()
        }
      }

      var headerDiv = header(o, movie)
      var centerDiv = center(o, movie, horizontaOffset, onTogglePlay).hide()
      var footerDiv = footer(o, onTogglePlay).hide()
      var subsDiv = subs(o, subsRaw, horizontaOffset).hide()
      var playDiv = play(o, onTogglePlay)

      var timelineDiv = o.component.timeline(o, onTimeChange)

      var videoDiv = o.component.video(o, videoUrl, onTimeUpdate)
      .css({
        cursor: 'pointer',
        background: 'black',
        opacity: 0,
      })
      .click(onTogglePlay)

      videoDiv[0].muted = false

      videoDiv[0].pause()

      var seekVideo = function() {
        console.log('seekVideo')
        videoDiv[0].removeEventListener('canplaythrough', seekVideo)
        if(o.store(`storyCurrentTime_${titleSlug}`)){
          var startSec = o.store(`storyCurrentTime_${titleSlug}`)
        } else {
          var startSec = 0
        }
        console.log('startSec', startSec)
        if(startSec == 0){startSec = 0.1} // ipad mini hack
        videoDiv[0].currentTime = startSec
        var showVideo = function(){
          console.log('showVideo')
          isPlaying = false
          footerDiv.show()
          if(!startSec || startSec == 0.1){
            videoDiv.css({
              opacity: 0,
            })
          } else {
            videoDiv.css({
              opacity: 1,
            })
          }
          // videoDiv[0].play()
          // if(videoDiv[0].paused){footerDiv.togglePlay()} // ipad mini hack
          videoDiv[0].removeEventListener('timeupdate', showVideo)
          done(div)
        }
        videoDiv[0].addEventListener('timeupdate', showVideo, false)
      }
  
      console.log('canplaythrough?')

      videoDiv[0].addEventListener('canplaythrough', seekVideo, false)
  
      var div = $('<div>')
      .css(o.mainDivCss)
      .addClass('iphoneNavbarFixTop')
      .addClass('iphoneNavbarFixBottom')  
      .append([

        videoDiv
        .css({
          position: 'fixed',
          objectFit: 'fit',
          overflow: 'hidden',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: -1,
          cursor: 'pointer',
        }),

        playDiv
        .css({
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: -2,
        }),

        headerDiv
        .css({
          flex: '0 1 auto',
          width: '100%',
          justifyContent: 'center',
          textAlign: 'center',
          zIndex: 1,
        }),

        $('<div>')
        .css({
          flex: '1 1 auto',
          pointerEvents: 'none',
        }),

        centerDiv
        .css({
          flex: '0 0 auto',
          width: '100%',
          padding: '1rem',
          minHeight: 0,
          zIndex: 1,
          pointerEvents: 'none',
        }),

        $('<div>')
        .css({
          flex: '1 1 auto',
          pointerEvents: 'none',
        }),

        subsDiv
        .css({
          flex: '0 0 auto',
          width: '100%',
          justifyContent: 'center',
          textAlign: 'center',
          minHeight: 0,
          zIndex: 1,
        }),

        footerDiv
        .css({
          flex: '0 0 auto',
          width: '100%',
          justifyContent: 'center',
          textAlign: 'center',
          minHeight: 0,
          zIndex: 1,
        }),

        $('<div>')
        .css({
          flex: '0 0 auto',
          height: '0.5rem',
          width: '100%',
        }),

        timelineDiv
        .css({
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 2,
        }),

      ])

      onTimeUpdate(0)

    }

    loadSubs(start)

  })

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/story/story.js